import { createTheme } from '@material-ui/core/styles';
import breakpoints from './breakpoints';

const CelebrityTheme = createTheme({
  breakpoints,
  typography: {
    base: {
      regular: 'Poppins, Roboto, Arial, sans-serif',
      bold: 'PoppinsBold, Roboto, Arial, sans-serif',
      light: 'PoppinsLight, Roboto, Arial, sans-serif',
      semiBold: 'PoppinsSemiBold, Roboto, Arial, sans-serif',
    },
    display: {
      regular: 'Kapra',
    },
    size: {
      0: '0.75rem', // 12px
      0.5: '0.75rem', // 12px
      1: '0.875rem', // 14px
      1.5: '0.875rem', // 14px
      2: '0.938rem', // 15px
      3: '1rem', // 16px
      4: '1.125rem', // 18px
      5: '1.188rem', // 19px
      6: '1.438rem', // 23px
      6.5: '1.4375rem', // 23px
      7: '1.75rem', // 28px
      8: '1.875rem', // 30px
      9: '2.063rem', // 33px
      10: '2.375rem', // 38px
      11: '2.875rem', // 46px
      12: '3.875rem', // 62px
      13: '4.375rem', // 70px
    },
  },
  palette: {
    primary: {
      main: '#002859',
      light: '#2588CD',
      dark: '#001871',
    },
    secondary: {
      // used for outlind buttons
      main: '#151617',
      dark: '#d16930',
    },
    error: {
      main: '#ED1D24',
      warning: '#FF6B00',
      text: '#A8151A',
    },
    warning: {
      main: '#B4860C',
    },

    shadow: '#06155626',
    white: '#FFFFFF',
    green: '#05A56B',
    shadowOpacity: '#06155626',

    blackScale: {
      opacity: '#00000061',
    },

    gray: {
      50: '#F7F8F9', // lightest background variation
      100: '#F5F5F5', // very light background variation
      150: '#EFF0F1', // background variation
      200: '#E5E5E5', // separator or disabled background
      250: '#CCCED8', // separator
      300: '#BBBBBB', // middle light tone
      400: '#7B7B7B', // disabled text
      500: '#787A7E', // main text color
      600: '#9F9F9F', // placeholder text color
      650: '#626366', // gray 1 for contrast (shifted down)
      700: '#333333', // dark text or icon color (shifted down)
      750: '#535455',
      800: '#151617', // neutral darkest (shifted down)
      850: '#8E8F90', // input border
      900: '#535353', // low middle light tone
    },

    text: {
      brand: '#083870',
      body: '#151617',
    },
    surface: {
      brand: '#E6EAF1',
    },
    border: {
      divider: '#BEC9DD',
    },
  },
  shadows: [
    'none',
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-1
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-2
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-3
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-4
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-5
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-6
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-7
    '0px 2px 4px 0px rgb(53 54 55 / 15%)', // elevation-8
  ],
  overrides: {
    MuiPaper: {
      root: {
        backgroundColor: '#FFFFFF',
      },
    },
    MuiOutlinedInput: {
      root: {
        borderColor: '#8E8F90',
        // Hover state
        '&:hover $notchedOutline': {
          borderColor: '#8E8F90',
        },
        '&$focused $notchedOutline': {
          borderColor: '#8E8F90',
        },
        '&:hover': {
          borderColor: '#8E8F90',
        },
      },
      // Default State
      notchedOutline: {
        borderColor: '#8E8F90',
      },
    },
  },
});

CelebrityTheme.typography.h1 = {
  color: CelebrityTheme.palette.text.body,
  fontSize: CelebrityTheme.typography.size[6.5],
  fontFamily: CelebrityTheme.typography.base.semiBold,
  [CelebrityTheme.breakpoints.up('lg')]: {
    fontSize: CelebrityTheme.typography.size[8],
  },
};
CelebrityTheme.typography.subtitle1 = {
  color: CelebrityTheme.palette.text.brand,
  fontSize: CelebrityTheme.typography.size[6.5],
  fontFamily: CelebrityTheme.typography.base.regular,
  [CelebrityTheme.breakpoints.up('lg')]: {
    fontSize: CelebrityTheme.typography.size[7],
  },
};
CelebrityTheme.typography.h3 = {
  color: CelebrityTheme.palette.error.main,
  fontSize: CelebrityTheme.typography.size[6],
};

export default CelebrityTheme;
